import React from 'react'
import { useStyles } from './styles'
import { formatDate } from 'src/utils'
import { PregnancyDiagnosisDto } from 'src/dto/pregnancy-diagnosis.dto'
import animalIcon from 'src/assets/images/calf_icon.png'

interface DiagnosisBadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  label?: string
  diagnosis: string | null
  item: PregnancyDiagnosisDto
}

const diagnosticStatus = (diagnosis: string | null, item: PregnancyDiagnosisDto) => {
  return diagnosis === 'prenha'
    ? `Data de nascimento: ${formatDate(item.dataParto)}`
    : diagnosis === 'vazia'
      ? 'Vazia'
      : 'Diagnóstico pendente'
}

export const DiagnosisBadge: React.FC<DiagnosisBadgeProps> = ({ label, diagnosis, item, ...rest }) => {
  const styles = useStyles()

  let diagnosisBadgeClass = styles.diagnosisBadgePendente

  if (diagnosis === 'prenha' || diagnosis === 'vazia') {
    diagnosisBadgeClass = styles.diagnosisBadgePositivo
  } else if (diagnosis === 'positivo') {
    diagnosisBadgeClass = styles.diagnosisBadgeNegativo
  }

  return (
    <span className={`${styles.diagnosisBadge} ${diagnosisBadgeClass}`} {...rest}>
      {label && (
        <span className={styles.diagnosisBadgeIcon}>
          <img src={animalIcon} alt='Animal Icon' />
        </span>
      )}
      {label || diagnosticStatus(diagnosis, item)}
    </span>
  )
}
